import React from 'react';
import KickImage from 'Reuseables/KickImage';
import propTypes from 'prop-types';
import { formatCurrency } from "../../utils"
import { connect } from "react-redux"

const ShippingFlatRateInfo = props => {
  
  const { ratio, currency } = props 
  const shippingFlatRateList = {
    sneakers: [
      {
        city: 'Jakarta',
        price: formatCurrency(40000, ratio, currency)
      },
      {
        city: 'Jawa',
        price: formatCurrency(80000, ratio, currency)
      },
      {
        city: 'Outside Jawa',
        price: formatCurrency(120000, ratio, currency)
      },
      {
        city: 'Papua',
        price: `${formatCurrency(200000, ratio, currency)}/kg`
      }
    ],
    apparels: [
      {
        city: 'Jakarta',
        price: formatCurrency(20000, ratio, currency)
      },
      {
        city: 'Jawa',
        price:  formatCurrency(40000, ratio, currency)
      },
      {
        city: 'Outside Jawa',
        price: formatCurrency(80000, ratio, currency)
      },
      {
        city: 'Papua',
        price: `${formatCurrency(200000, ratio, currency)}/kg`
      }
    ]
  }
  const selected = props.isApparels? shippingFlatRateList.apparels: shippingFlatRateList.sneakers;

  return(
    <div>
      <div>
        We charge a flat-rate shipping. Every package includes bubble wrap and exterior boxing.
      </div>
      {
        selected.map((item, index)=>(
          <div key={index}>
            {item.city} - {item.price}
          </div>
        ))
      }
    </div>
  )
}
ShippingFlatRateInfo.defaultProps = {
  isApparels: false
}
ShippingFlatRateInfo.propTypes ={
  isApparels: propTypes.bool
}

const mapStateToProps = state => ({ 
  ratio: state.dataAuth.userCurrency.ratio,
  currency: state.dataAuth.userCurrency.currency
}) 
export default connect(mapStateToProps)(ShippingFlatRateInfo);


